// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"checkboxInput_checkboxContainer__1wetg","checkbox":"checkboxInput_checkbox__U7XoM","checkboxLabel":"checkboxInput_checkboxLabel__217Ec"};